import { Section, Text } from "@react-email/components";
import { EmailHeading } from "@/email/components/EmailHeading";
import { EmailWrapper } from "@/email/components/EmailWrapper";
import { isOurTenant } from "@/store/tenant/selectors";
import { User } from "@/types";
import { ITenant } from "@/types/tenant";

interface FeedbackEmailProps {
    user?: User;
    url: string;
    feedback: string;
    tenant: ITenant | null;
}

const FeedbackEmail = ({ user, feedback, url, tenant }: FeedbackEmailProps) => {
    const is1TemplateTenant = isOurTenant(tenant);
    const preview = is1TemplateTenant ? "1Template" : "Your";
    const subdomain = tenant?.subdomain;
    return (
        <EmailWrapper
            preview={`${preview} [${subdomain}] User Feedback`}
            tenant={tenant}
        >
            <EmailHeading>User Feedback</EmailHeading>
            <Section>
                {user && (
                    <Text>
                        User: {user?.email} ({user?.id})
                    </Text>
                )}
                {url && <Text>URL: {url}</Text>}
                {feedback && <Text>Feedback: {feedback}</Text>}
            </Section>
        </EmailWrapper>
    );
};

export default FeedbackEmail;
